<arpio-center-panel>
  <h3 class="panel-title">Oops...</h3>
  @if (awsToken) {
    <div class="margin-top">The token provided by the AWS Marketplace is invalid.</div>
  } @else {
    <div class="margin-top">Your request to subscribe through the AWS Marketplace is missing a subscription token.</div>
  }
  <div class="margin-top">
    Please go back to the AWS Marketplace and find {{ uiService.productName }} under "Your Software". You should then be
    able to navigate back here with a valid token.
  </div>
  <div class="margin-top">For additional help, contact {{ uiService.supportContact }}.</div>
</arpio-center-panel>
